// extracted by mini-css-extract-plugin
export default {"GoalsEdit":"style_GoalsEdit__TL7op","content":"style_content__nN+Vz"};